import { deliverableApi } from '../services/api/deliverable';
import { uploadWithProgress } from './contentUploadUtils';

/**
 * Uploads a single UGC content file and registers it against its content unit.
 *
 * `contentKey` is the content submission unit key. The backend treats a key
 * containing an underscore as a carousel item (keyed `${requirementId}_...`,
 * copied from the base unit) and a key equal to the requirementId as the base
 * single unit — so callers must key slots accordingly.
 */
export const uploadAndSubmitUgcContent = async (
  params: { collabId: string; clientId: string; contentKey: string; file: File; influencerId?: string },
  onProgress: (pct: number) => void
): Promise<void> => {
  const { collabId, clientId, contentKey, file, influencerId } = params;

  const { url, filePath } = await deliverableApi.getUGCUploadUrl({
    fileName: file.name,
    contentType: file.type,
    collabId,
    contentId: contentKey,
    clientId,
  }, influencerId);

  await uploadWithProgress(url, file, onProgress);

  await deliverableApi.submitUGCContent({
    collabId,
    postUrl: filePath,
    contentId: contentKey,
  }, influencerId);
};
